import { cn, getAcronymFromString } from '@fortem-monorepo/js-utilities'
import { Avatar, AvatarFallback } from '@fortem-monorepo/react-ui'

export interface AttributionsActionedByProps extends React.ComponentProps<'div'> {
  name: string
}

export const AttributionsActionedBy: React.FC<AttributionsActionedByProps> = ({ name, className, ...props }) => {
  return (
    <div className={cn('flex items-center gap-2', className)} {...props}>
      <Avatar className="border">
        <AvatarFallback className="text-xs rounded-lg">{getAcronymFromString(name)}</AvatarFallback>
      </Avatar>
      <span className="text-sm text-muted-foreground whitespace-nowrap font-medium">{name}</span>
    </div>
  )
}
